import { DecisionContext } from "@/dbot/common/commonDomain";
import { identity } from "lodash";
import { DecisionType } from "@/common/decisions";
import { NumberFieldModel, RadioFieldModel } from "@/common/commonForms";

export enum PowerOfAttorneyFor {
  dividend = "dividend",
  groupContribution = "groupContribution",
  dividendAndGroupContribution = "dividendAndGroupContribution",
}

export type DividendPowerOfAttorney = {
  type: DecisionType.dividendPowerOfAttorney;
  powerOfAttorneyFor: PowerOfAttorneyFor;
  powerOfAttorneyLimit?: number;
  boardDecidesMaxAmount?: boolean;
};

export class DividendPowerOfAttorneyForm {
  readonly type = DecisionType.dividendPowerOfAttorney;
  context: DecisionContext<DividendPowerOfAttorney>;
  data?: DividendPowerOfAttorney;
  powerOfAttorneyFor: RadioFieldModel<PowerOfAttorneyFor>;
  boardDecidesMaxAmount: RadioFieldModel<boolean>;
  powerOfAttorneyLimit: NumberFieldModel;

  constructor(context: DecisionContext<DividendPowerOfAttorney>, data?: DividendPowerOfAttorney) {
    this.context = context;
    this.data = data;
    this.powerOfAttorneyFor = new RadioFieldModel<PowerOfAttorneyFor>({
      value: data?.powerOfAttorneyFor ?? PowerOfAttorneyFor.dividend,
      options: Object.values(PowerOfAttorneyFor),
      idFn: identity,
      labelFn: (v) => ({ key: `decisions.dividend.powerOfAttorneyFor.${v}` }),
    });
    this.boardDecidesMaxAmount = new RadioFieldModel<boolean>({
      value: data ? (data.boardDecidesMaxAmount ?? !data.powerOfAttorneyLimit) : true,
      options: [true, false],
      idFn: identity,
      labelFn: (v) => ({ key: `decisions.dividend.boardDecidesMaxAmount.${v}` }),
    });
    this.powerOfAttorneyLimit = new NumberFieldModel({
      value: data?.powerOfAttorneyLimit,
      isPositive: true,
      required: true,
    });
  }

  validate(): boolean {
    return this.boardDecidesMaxAmount.value || this.powerOfAttorneyLimit.validate();
  }

  get isProjectLocked(): boolean {
    return this.context.isLocked;
  }

  get isValid(): boolean {
    return this.powerOfAttorneyLimit.isValid;
  }
}
